import * as React from 'react'
import {createRoot} from 'react-dom/client'
import App from './App'
import './index.scss'
import * as serviceWorker from './serviceWorker'
import {createClient} from './graphql/config'
import {loginOnSessionTimeout} from './utils/auth'
import {getCookie} from './utils/genericUtils'
import {isSameOrBefore, fromUnixTimestamp} from './utils/dateAdapter'

// Create root once
const container = document.getElementById('root')
if (!container) throw new Error('Failed to find root element')
const root = createRoot(container)

const initializeApp = async () => {
  const userInfo = getCookie('loginUserInfo')
  let isExpired = true
  let expiry = 0
  if (userInfo && decodeURIComponent(userInfo)) {
    const exp = JSON.parse(decodeURIComponent(userInfo)).exp
    expiry = Number(exp)
    isExpired = isSameOrBefore(fromUnixTimestamp(expiry), new Date())
  }
  if (isExpired) {
    loginOnSessionTimeout()
  } else {
    const client = await createClient()
    // periodicallyRefreshToken(expiry)
    root.render(<App client={client} />)
  }
}
if (window.location.pathname.indexOf('get-social-code') > -1) {
  window.opener.postMessage(window.location.search, window.location.origin)
  window.close()
  root.render(<div>Hi, Get the code</div>)
} else {
  initializeApp()
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
